import { ErrorInfo } from "react";
import axios from "axios";

// 2026-06-06 보안 — 과거 이 파일은 슬랙 webhook URL(REACT_APP_REPORT_SLACK_URL)을
// 번들에 담아 브라우저에서 직접 호출했다. 누구나 그 URL 로 슬랙에 임의 메시지 주입 가능.
// → webhook 을 백엔드 뒤로 옮김. 프론트는 우리 백엔드(/app/client-errors)로 구조화된
// 에러 정보만 보내고, 백엔드가 메시지를 조립해 텔레그램으로 알린다. 시크릿은 번들에서 제거.
const ERROR_REPORT_URL = `${process.env.REACT_APP_API ?? ""}/app/client-errors`;

const truncate = (s: string | null | undefined, max: number) =>
  s ? s.slice(0, max) : undefined;

/**
 * ErrorBoundary 에서 잡힌 렌더 에러를 백엔드로 리포트한다 (production 한정).
 * 비로그인 상태에서도 발생할 수 있으므로 JWT 인터셉터를 타지 않는 plain axios 사용.
 * fire-and-forget — 실패해도 앱 흐름에 영향 없음.
 */
export const reportClientError = (error: Error, info: ErrorInfo) => {
  if (process.env.REACT_APP_ENV !== "production") return;
  if (!process.env.REACT_APP_API) return;

  axios
    .post(
      ERROR_REPORT_URL,
      {
        name: truncate(error.name, 200),
        stack: truncate(error.stack, 4000),
        componentStack: truncate(info?.componentStack, 4000),
        digest: truncate((info as { digest?: string })?.digest, 200),
        env: process.env.REACT_APP_ENV,
        url: typeof window !== "undefined" ? window.location.href : undefined,
      },
      { timeout: 5000 }
    )
    .catch(() => {
      console.log("Failed to Send Error Alert");
    });
};
